import React from 'react';
import c from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import { createSearchFacetUrl } from '../../../../components/Search/helpers';
import { SEARCHKIT_INDEX_PROMOTED_CONTENT_THEMES } from '../../../../config/constants';
import type { PillarProps } from '..';

import './style.scss';

const PillarTeaser: React.FC<PillarProps> = ({ entity, classNames, link }) => {
  const name = entity.getIn(['name', 0, 'value']);
  const description = entity.getIn(['description', 0, 'value']);
  const image = entity.getIn(['field_media_image', 0, 'source'], false);
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], false);

  const url = createSearchFacetUrl({
    pathname: link,
    index: SEARCHKIT_INDEX_PROMOTED_CONTENT_THEMES,
    facetType: 'menu',
    attribute: 'pillar',
    value: name,
  });

  return (
    <div className={c('PillarTeaser', classNames)}>
      <CoreLink to={url} className="PillarTeaser__link">
        <div className="PillarTeaser__inner">
          {image && (
            <img src={image} alt={imageAlt} />
          )}
          <div className="PillarTeaser__inner__title asH4">{name}</div>
          <p>{description}</p>
          <div className="PillarTeaser__arrow"><span className="icon icon-arrow-right" /></div>
        </div>
      </CoreLink>
    </div>
  );
};

export default PillarTeaser;
